import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  FORSUBMIT
} from '@hobs/constants/customServiceRequests';

class ServiceRequests extends BaseReducer {
  static defaultState = {
    forSubmit: {
      units: [],
      annexes: [],
      groups: []
    }
  };
  constructor() {
    super(ServiceRequests.defaultState);

    this.actionMap = {
      [FORSUBMIT.SUCCESS]: this.addForSubmitData
    };
  }

  addForSubmitData = (state, action) => {
    return Object.assign({}, state, { forSubmit: action.results });
  };
}
export default new ServiceRequests().reducer;
